import { Component, OnInit } from '@angular/core';
import {ChartDataSets, ChartOptions, ChartType} from 'chart.js';
import {Color, Label} from 'ng2-charts';
import * as moment from 'moment';
import {ConfService} from '../../conf.service';
import {LeftpanelComponent} from '../../leftpanel/leftpanel.component';
import {MatIconRegistry} from '@angular/material';
import {DomSanitizer} from '@angular/platform-browser';
import {ActivatedRoute, Router} from '@angular/router';
import {Location} from '@angular/common';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-automation-dashboard',
  templateUrl: './automation-dashboard.component.html',
  styleUrls: ['./automation-dashboard.component.scss']
})
export class TestResultsDashboardComponent implements OnInit {

  partnerKey = localStorage.getItem('partnerKey');

  public canvasWidth = 200;
  public needleValue = 0;
  public centralLabel = '';
  public name: string;
  public options = {
    hasNeedle: true,
    needleColor: 'gray',
    needleUpdateSpeed: 1000,
    arcColors: ['#f44041', '#fadb42', '#48ce49'],
    arcDelimiters: [40, 80],
    rangeLabel: ['0', '100'],
    needleStartValue: 50,
  };

  //chart
  public lineChartData: ChartDataSets[] = [
    { data: [], label: 'Passed' },
    { data: [], label: 'Failed' },
    { data: [], label: 'Skipped' }
  ];

  public lineChartLabels: Label[] = [];

  public lineChartOptions: ChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      yAxes: [{}],
      xAxes: []
    }

  };
  public lineChartColors: Color[] = [
    {
      borderColor: 'rgba(15, 250, 73, 0.78)',
      backgroundColor: 'rgba(0, 204, 51, 0.16)',
    },
    {
      borderColor: 'rgba(251, 92, 65, 0.86)',
      backgroundColor: 'rgba(204, 0, 0, 0.16)',
    },
    {
      borderColor: 'rgba(10, 14, 11, 0.33)',
      backgroundColor: 'rgba(10, 14, 11, 0.11)',
    },
  ];
  public lineChartLegend = true;
  public lineChartType: ChartType = 'line';
  public lineChartPlugins = [];
  //chart

  projects = [];
  projectsArray: any;

  countryColumns = ['PRODUCT',  'USA', 'UAE', 'INDIA'];
  componentLoading = true;

  resultsPageType = '';

  buildsDataLoading = false;
  buildDataFound = false;

  executors: any;

  showBuildAnalytics = false;
  projectData: any;
  buildsData: any;
  buildsCurrentActiveIndex = -1;

  filterData: any[] = [];
  searchText: string;
  columnSearch = ['executor_name', 'executor_version'];
  settings = {
    text: 'Select attribute(s) to search instantly',
    selectAllText: 'Select All',
    unSelectAllText: 'Unselect All',
    enableSearchFilter: true,
    autoPosition: false
  };
  itemList = [];
  columns = ['API Name', 'API Version', 'Type', 'Created', 'Last Updated', 'Results'];
  executorMappingToSort = ['executor_name', 'executor_version', 'executor_type', 'creationTime', 'lastModifiedTime', ''];


  internalTestSuiteResults: any;

  queryTime = 'week';
  dateRanges = [
    {display_name: 'Past Day', range: 'day'},
    {display_name: 'Past Week', range: 'week'},
    {display_name: 'Past Month', range: 'month'},
    {display_name: 'Past Year', range: 'year'},
    {display_name: 'All Time', range: 'all'},
  ];

  ranges: any = {
    'Today': [moment(), moment()],
    'Last 7 Days': [moment().subtract(6, 'days'), moment()],
    'Last 30 Days': [moment().subtract(29, 'days'), moment()],
    'This Month': [moment().startOf('month'), moment().endOf('month')],
  };

  selectedExecutor: any;

  resultsTitle: any;

  partner = localStorage.getItem('partner');
  account = localStorage.getItem('account');

  selectedDateRange: {startDate: moment.Moment, endDate: moment.Moment} = {startDate: moment().subtract(6, 'days'), endDate: moment()};

  minDate = moment('2021-01-01', 'YYYY-MM-DD');
  maxDate = moment();

  isApiTestSuite = false;

  constructor(public confPost: ConfService,
              public platform: LeftpanelComponent,
              private router: Router,
              private location: Location,
              private route: ActivatedRoute,
              iconRegistry: MatIconRegistry,
              sanitizer: DomSanitizer) {
    iconRegistry.addSvgIcon(
        'metrics',
        sanitizer.bypassSecurityTrustResourceUrl('/assets/img/metrics.svg'));
  }

  ngOnInit() {

    // this.confPost.getAutomationProjects( 'partner=' + 'dev-gilded').subscribe(projects => {
    //
    //   this.projectsArray = projects;
    //   this.getAutomationResultForProjects();
    // });

    for (let t = 0; t < this.columnSearch.length; t++) {
      if (this.columnSearch[t] !== '') {
        const tempObj = {};
        tempObj['id'] = t;
        tempObj['itemName'] = this.columns[t];
        tempObj['filter'] = this.columnSearch[t];
        this.itemList.push(tempObj);
        this.filterData.push(tempObj);
      }
    }
    this.subscribeRouteQueries();
  }

  getTestSuiteApis(fetchAnyway = false) {
    return new Promise(async (resolve, reject) => {
      if (!this.executors || fetchAnyway) {
        this.confPost.getApiExecutorsByPartnerAccount(this.partner, this.account, 'partner=' + this.partner + '&account=' + this.account + '&type=TESTSUITE,EXTERNALTESTSUITE&fields=' + 'executor_name,executor_version,partner,account_id,executor_type,creationTime,lastModifiedTime').toPromise().then(projects => {
          this.executors = projects;
          this.platform.getTSRExecutors(this.executors.length > 0);
          resolve('success');
        }, error => {
          this.executors = undefined;
          resolve(error);
        });
      } else {
        resolve('success');
      }
    });
  }

  subscribeRouteQueries() {
    const obsComb = Observable.combineLatest(this.route.params, this.route.queryParams,
        (params, qparams) => ({ params, qparams }));

    if (this.location['_platformLocation'].location.pathname.includes('/test-results')) {
      obsComb.subscribe( ap => {
        const qparams = ap.qparams;
        if (ap.params.submenu) {
          if (ap.params.submenu === 'testsuite') {
            if (qparams.executor_name && qparams.executor_version) {
              this.componentLoading = true;
              Promise.resolve(this.getTestSuiteApis()).then(response => {
                if (this.executors) {
                  let valFound = false;
                  for (const val of this.executors) {
                    if (val.executor_name === qparams.executor_name && val.executor_version === qparams.executor_version) {
                      this.selectedExecutor = val;
                      this.getAutomationResultForProject(this.selectedExecutor);
                      valFound = true;
                      break;
                    }
                  }
                  if (!valFound) {
                    this.platform.openSnackBar('Testsuite API not found.', 'Error', {
                      duration: 5000,
                      verticalPosition: 'top',
                      horizontalPosition: 'center'
                    });
                    this.router.navigateByUrl('/test-results');
                    this.showBuildAnalytics = false;
                  }
                } else {
                  this.platform.handleErrorGracefully(response, 'Unable to retrieve test-suite APIs. Please try again later');
                  this.showBuildAnalytics = false;
                }
              });
            } else {
              this.setHomePage();
            }
          } else if (ap.params.submenu === 'api') {
            this.isApiTestSuite = true;
            if (qparams.executor_name && qparams.executor_version) {
              this.selectedExecutor = {executor_name: qparams.executor_name, executor_version: qparams.executor_version, isEntity: false};
              this.getAutomationResultForProject(this.selectedExecutor);
            } else if (qparams.entity && qparams.version) {
              this.selectedExecutor = {executor_name: qparams.entity, executor_version: qparams.version, isEntity: true};
              this.getAutomationResultForProject(this.selectedExecutor);
            } else if (qparams.resultId) {
              this.selectedExecutor = {id: qparams.resultId};
              this.getAutomationResultForProject(this.selectedExecutor);
            }
          } else {
            this.router.navigateByUrl('/test-results');
          }
        } else {
          this.setHomePage();
        }
      });
    }
  }

  setHomePage() {
    this.componentLoading = true;
    this.selectedExecutor = undefined;
    Promise.resolve(this.getTestSuiteApis()).then(response => {
      this.showBuildAnalytics = false;
      this.componentLoading = false;
    });
  }

  checkFilter() {
    if (!this.filterData || this.filterData === [] || this.filterData === null) {
      alert('Please select an attribute to filter.');
      this.searchText = '';
    }
  }

  getCreatedDate(val) {
    if (val) {
      return this.platform.timeConverter(val);
    } else {
      return '';
    }
  }

  projectsHasData() {
    if (this.projects.length > 0) {
      for (const project of this.projects) {
        if (project.data.length > 0) {
          return true;
        }
      }
      return false;
    } else {
      return false;
    }
  }

  getAutomationResultForProjects() {
    const promises = [];

    if (this.projectsArray) {
      this.projects = [];

      for (const project of this.projectsArray) {
        promises.push(this.getAutomationResultForProject(project));
      }

      this.componentLoading = true;

      Promise.all(promises)
          .then(async (results) => {
            let totalTests = 0;
            let passedTests = 0;
            for (const project of this.projects) {
              for (const build of project.data) {
                totalTests = totalTests + build.tests;
                passedTests = passedTests + build.passed;
                this.needleValue = Math.floor(passedTests / totalTests * 100);
              }
            }
            this.name = 'Automation Health' + ': ' + this.needleValue + '%';
            this.showBuildAnalytics = false;
            this.componentLoading = false;
          });
    }
  }

  async getAutomationResultForProject(project) {
    return new Promise(async (resolve, reject) => {
      const d = new Date(Date.now());
      d.setDate(d.getDate() - 7);
      this.projects = [];

      this.buildsDataLoading = true;

      if (!this.isApiTestSuite) {
        this.resultsPageType = project['executor_type'].toUpperCase();
        if (project['executor_type'] && project['executor_type'].toUpperCase() === 'EXTERNALTESTSUITE') {
          this.confPost.getData('services', 'services', 'v1', 'testsuiteBuilds', 'projectName=' + project['partner'] + '-' + project['account_id'] + '-' + project['executor_name'] + '-' + project['executor_version'] + '&startedAt.gte=' + this.selectedDateRange.startDate.startOf('day').valueOf() + '&endedAt.lte=' + this.selectedDateRange.endDate.endOf('day').valueOf() + '&buildStatus=success&sort=-startedAt').subscribe(response => {
            let result: any;
            result = response;

            const build = {
              data: result,
              noData: result.length === 0,
              project: project,
              lineChartData: [
                {data: [], label: 'Passed'},
                {data: [], label: 'Failed'},
                {data: [], label: 'Skipped'}
              ],
              lineChartLabels: [],
              latestBuild: result.length === 0 ? null : result[0],
              doughnutChartData: result.length === 0 ? [0, 0, 0] : [result[0]['passed'], result[0]['failed'], result[0]['skipped']],
              doughnutChartLabels: ['Passed', 'Failed', 'Skipped'],
              chartType: 'doughnut',
              doughnutColors: [
                {
                  backgroundColor: [
                    '#00af00',
                    '#f7464a',
                    '#ff9900'
                  ]
                }
              ],
              doughnutChartOptions: {
                responsive: false,
                legend: {
                  display: true,
                  position: 'right',

                },
                plugins: {
                  title: {
                    display: true,
                    text: 'Tests',
                    padding: {
                      top: 10,
                      bottom: 30
                    }
                  }
                }
              },
            };
            this.setChartData(build.data, build.lineChartData, build.lineChartLabels);
            this.projects.push(build);

            this.openFilterData(0, {});

            resolve('success');
          }, error => {
            resolve('failed');
          });
        } else {
          this.showBuildAnalytics = true;
          this.componentLoading = false;
          this.confPost.getData('services', 'services', 'v1', 'apiCallLogs', 'partner=' + this.partner + '&account=' + this.account + '&name=' + project['executor_name'] + '&version=' + project['executor_version'] + '&timestamp.gte=' + this.selectedDateRange.startDate.startOf('day').valueOf() + '&timestamp.lte=' + this.selectedDateRange.endDate.endOf('day').valueOf() + '&sort=-timestamp').subscribe(response => {
            let resp: any;
            resp = response;
            if (resp.length > 0) {
              this.internalTestSuiteResults = [];
              this.buildDataFound = true;
              for (const val of resp) {
                this.internalTestSuiteResults.push({
                  name: val['name'],
                  version: val['version'],
                  timestamp: val['timestamp'],
                  results: JSON.parse(val['response']['body'])
                });
              }
            } else {
              this.buildDataFound = false;
            }

            this.buildsDataLoading = false;
          }, error => {
            this.internalTestSuiteResults = undefined;
            this.buildsDataLoading = false;
            this.buildDataFound = false;

          });
        }
      } else {
        this.showBuildAnalytics = true;
        this.componentLoading = false;
        let query = '';
        if (project.id && project.id !== '') {
          query = 'resultId=' + project.id;
        } else {
          if (project.isEntity) {
            query = 'entity_name=' + project.executor_name + '&entity_version=' + project.executor_version + '&startTime=' + this.selectedDateRange.startDate.startOf('day').valueOf() + '&endTime=' + this.selectedDateRange.endDate.endOf('day').valueOf();
          } else {
            query = 'executor_name=' + project.executor_name + '&executor_version=' + project.executor_version + '&startTime=' + this.selectedDateRange.startDate.startOf('day').valueOf() + '&endTime=' + this.selectedDateRange.endDate.endOf('day').valueOf();
          }
        }
        this.resultsPageType = 'TESTSUITE';
        this.confPost.getAPITestsuiteCallLogs(this.partner, this.account, this.partnerKey, query).subscribe(response => {
          this.internalTestSuiteResults = response;

          if (this.internalTestSuiteResults.length > 0) {
            this.resultsTitle = this.internalTestSuiteResults[0]['name'] && this.internalTestSuiteResults[0]['version'] ? this.internalTestSuiteResults[0]['name'] + ' (' + this.internalTestSuiteResults[0]['version'] + ')' : '-';
            this.buildDataFound = true;
          } else {
            this.buildDataFound = false;
          }

          this.buildsDataLoading = false;
        }, error => {
          this.internalTestSuiteResults = undefined;
          this.buildsDataLoading = false;
          this.buildDataFound = false;

        });
      }
    });
  }



  setChartData(buildsData, lineChartData, lineChartLabels) {
    if (buildsData) {
      for (let i = buildsData.length - 1; i >= 0; i--) {
        const data = buildsData[i];
        if (data.hasOwnProperty('passed') && data.hasOwnProperty('failed') && data.hasOwnProperty('skipped') && data.hasOwnProperty('id')) {
          lineChartData[0].data.push(data.passed);
          lineChartData[1].data.push(data.failed);
          lineChartData[2].data.push(data.skipped);
          lineChartLabels.push('#' + (data.buildNumber ? data.buildNumber : data.id));
        }
      }
    }
  }

  filterDataWithQuery(projectIndex, querydata) {
    const keys = Object.keys(querydata);
    let filteredArr = [];

    if (keys.length > 0) {
      for (const build of this.projects[projectIndex].data) {
        for (const key of keys) {
          for (const val of querydata[key]) {
            if (build[key] && build[key] === val) {
              filteredArr.push(build);
            }
          }
        }
      }
    } else {
      filteredArr = JSON.parse(JSON.stringify(this.projects[projectIndex].data));
    }
    return filteredArr;
  }

  getCountryPassRate(projectIndex, querydata) {
    const filteredArr = this.filterDataWithQuery(projectIndex, querydata);

    if (filteredArr.length > 0) {
      return Math.floor(filteredArr[0].passed / filteredArr[0].tests * 100);
    } else {
      return 0;
    }
  }

  getCountryStatus(projectIndex, querydata) {
    const filteredArr = this.filterDataWithQuery(projectIndex, querydata);

    if (filteredArr.length > 0) {
      const passRate = Math.floor(filteredArr[0].passed / filteredArr[0].tests * 100);
      if (passRate <= 40) {
        return 'fa fa-times-circle icn-r';
      } else if (passRate > 40 && passRate < 80) {
        return 'fa fa-exclamation-triangle icn-y';
      } else {
        return 'fa fa-check-circle icn-g';
      }
    } else {
      return 'fa fa-times-circle icn-b';
    }
  }

  openFilterData(projectIndex, querydata, currentActiveIndex = -1 ) {
    const filteredArr = this.filterDataWithQuery(projectIndex, querydata);

    this.buildsData = filteredArr;
    this.projectData = this.projects[projectIndex]['project'];

    this.showBuildAnalytics = true;
    this.componentLoading = false;
    this.buildsDataLoading = false;

    if (this.buildsData.length > 0) {
      this.buildsCurrentActiveIndex = currentActiveIndex;
      this.buildDataFound = true;
    } else {
      this.showBuildAnalytics = true;
      this.buildDataFound = false;

      // this.platform.openSnackBar('Test results data not found for the API.', 'Error', {
      //   duration: 5000,
      //   verticalPosition: 'top',
      //   horizontalPosition: 'center'
      // });
      // this.router.navigateByUrl('/test-results');
    }
  }

  getPassRate(passCount, total) {
    return Math.floor(passCount / total * 100);
  }

  getDate(timeStamp, dateWithSlash = false) {
    if (timeStamp) {
      const date_ob = new Date(timeStamp);
      let hours = date_ob.getHours();
      const minutes = ('0' + date_ob.getMinutes()).slice(-2);
      const seconds = ('0' + date_ob.getSeconds()).slice(-2);
      const ampm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12;
      hours = hours ? hours : 12;


      if (dateWithSlash) {
        return (date_ob.getMonth() + '/' + date_ob.getDate()) + '/' + date_ob.getFullYear() + ' ' + hours + ':' + minutes + ':' + seconds + ' ' + ampm;
      } else {
        return (date_ob.toDateString()) + ' ' + hours + ':' + minutes + ':' + seconds + ' ' + ampm;
      }
    } else {
      return '-';
    }
  }

  showMainPage() {
    this.router.navigateByUrl('/test-results');
    this.showBuildAnalytics = false;
    this.componentLoading = false;
  }
}
